(() => {
  if (window.DemeleExperienceLoaded) return;
  window.DemeleExperienceLoaded = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observedVideos = new Set();
  let videoObserver;

  const safePlay = (video) => {
    if (reducedMotion.matches || document.hidden || !video.isConnected) return;
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(() => {});
  };

  const setVideoState = (video, shouldPlay) => {
    video.dataset.dmleVisible = shouldPlay ? 'true' : 'false';
    if (shouldPlay) safePlay(video);
    else video.pause();
  };

  const ensureVideoObserver = () => {
    if (videoObserver || !('IntersectionObserver' in window)) return;
    videoObserver = new IntersectionObserver(
      (entries) => entries.forEach((entry) => setVideoState(entry.target, entry.isIntersecting)),
      { rootMargin: '160px 0px', threshold: 0.08 }
    );
  };

  const initVideos = (root = document) => {
    const videos = root.querySelectorAll('video[autoplay], video[data-dmle-autoplay]');
    ensureVideoObserver();

    videos.forEach((video) => {
      if (observedVideos.has(video)) return;
      observedVideos.add(video);
      video.muted = true;
      video.playsInline = true;

      if (reducedMotion.matches) {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }

      if (videoObserver) videoObserver.observe(video);
      else safePlay(video);
    });
  };

  const syncMotionPreference = () => {
    observedVideos.forEach((video) => {
      if (reducedMotion.matches) video.pause();
      else if (video.dataset.dmleVisible !== 'false') safePlay(video);
    });
  };

  const boot = () => initVideos(document);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('visibilitychange', syncMotionPreference);
  document.addEventListener('shopify:section:load', (event) => initVideos(event.target));

  if (typeof reducedMotion.addEventListener === 'function') reducedMotion.addEventListener('change', syncMotionPreference);
  else if (typeof reducedMotion.addListener === 'function') reducedMotion.addListener(syncMotionPreference);
})();
